import styled, { css, keyframes } from 'styled-components'

import { fontType, toRem, transition } from '../../../styles/functions'

interface IProps {
	submenuIsOpen: boolean
}

const showMenu = keyframes`
  0% {
    transform: translateY(-60px);
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
`

const rotateArrow = keyframes`
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(0deg);
  }
`

export const SubmenuWrapper = styled.ul<IProps>`
	margin: 0 8px 6px;
	border-radius: 6px;
	overflow: hidden;
	background: ${({ theme }) => theme.colors.white};
	box-shadow: 0px 2px 3px #00000014;

	${transition()}

	.submenu {
		background: ${({ theme }) => theme.colors.white};
		padding: 18px 16px;
		display: flex;
		align-items: center;
		cursor: pointer;
		text-decoration: none;
		position: relative;

		${transition()}

		svg {
			flex-shrink: 0;
			width: 20px;
			height: 20px;
			margin-right: 16px;
			color: ${({ theme }) => theme.colors.blue};
			${transition()}
		}

		.submenu-text {
			width: 100%;
			font-size: ${toRem(12)};
			color: ${({ theme }) => theme.colors.blue};
			${fontType(1)};
			${transition()}
		}

		.arrow-icon {
			display: flex;
			align-items: center;

			img.submenuIsOpen {
				transform: rotate(180deg);
				transition: 0.3s;
			}
			img.submenuIsClose {
				animation: 0.3s ${rotateArrow} ease-out;
			}
		}
	}

	${(props) =>
		props.submenuIsOpen &&
		css`
			.submenu::after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 16px;
				right: 16px;
				height: 1px;
				background: ${({ theme }) => theme.colors.lightGrey2};
			}
		`}
`

export const SubmenuRouteItem = styled.li<IProps>`
	list-style: none;
	background: ${({ theme }) => theme.colors.white};

	animation: 0.3s ${showMenu} ease-out;

	.nav-link {
		display: flex;
		align-items: center;

		padding: 14px 16px;
		background: ${({ theme }) => theme.colors.white};
		cursor: pointer;
		text-decoration: none;

		.nav-text {
			font-size: ${toRem(12)};
			color: ${({ theme }) => theme.colors.blue};
			${fontType(1)};
			${transition()}
		}

		&:hover .nav-text {
			opacity: 0.7;
		}

		&.active {
			.nav-text {
				${fontType(2)};
				margin-left: 12px;
			}
		}
	}
`
